module.exports = __webpack_public_path__ + "static/media/welcome.fc63a127.jpeg";